import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AuthOPEEnum} from "./AuthOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  email!: string;
  baseFeUrl!: string;
  action!: string;
}


/**
 * GetWidgetsCB class
 */
export class ResetPasswordCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AuthOPEEnum.ResetPassword);
    this.i = new I();
    this.o = new O();
  }

}
